/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamMembershipSummarySchema = z.object({
  commitment: z.number(),
  endDate: z.iso.date().nullish(),
  membershipId: z.int(),
  roleId: z.int().nullish(),
  roleName: z.string().nullish(),
  startDate: z.iso.date().nullish(),
});
